// extracted by mini-css-extract-plugin
export default {"truncate":"P6OWP3HmLjnZGT69yMvh","descriptionLabel":"rAcVqVtAg4fCkInsHv7Z","descriptionLabelMobile":"P0f3yafVqMQKUeItzlnE"};